import { Col, Row } from 'antd'
import React from 'react'
import { DownloadOutlined } from '@ant-design/icons'
import { DocumentsProposalFragment } from './Documents.generated-types'

interface CompProps {
  proposal: DocumentsProposalFragment
}

export const Documents: React.FC<CompProps> = ({ proposal: { documents } }) => {
  const documentsList = documents.map((doc, i) => {
    return (
      <Row key={i}>
        <a href={`https://${doc.URL}`} rel='noreferrer' target='_blank'>
          <DownloadOutlined />
          {` ${doc.filename}`}
        </a>
      </Row>
    )
  })

  return <Col>{documentsList}</Col>
}
